var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"sync-state sync-state-syncing\" style=\"display: none;\">\n    <i class=\"fa fa-refresh fa-spin menu-icon\"></i>\n</div>\n\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./system/ui/template/diagram-sync-state.hbs
// module id = 1162
// module chunks = 0